import Checkbox from "@material-ui/core/Checkbox"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import React, { useState } from "react"

interface ComponentProps {
    fieldName: string,
    label: string,
    onConfirm: (fieldName: string, checked: boolean) => void,
    initialChecked?: boolean,
    disabled?: boolean,
}

const Checked = (props: ComponentProps) => {
    const { fieldName, label, onConfirm, initialChecked = false, disabled = false } = props
    const [ checked, setChecked ] = useState(initialChecked)
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked)
        onConfirm(fieldName, event.target.checked)
    }
    return (
        <FormControlLabel
            control={
                <Checkbox
                    checked={checked}
                    color="primary"
                    onChange={handleChange}
                    disabled={disabled}
                />}
            label={label}
            labelPlacement="start"
        />
    )
}

export default Checked
